import { http, HttpResponse } from "msw";
import { PlessService } from "../../../app/shared/pless-service.model";

export const kymw0908Handlers = [
  http.post(PlessService.SERVICE.getCouponGoodsNo.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(getCouponGoodsNoResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),
]

const getCouponGoodsNoResponse = {
  status: "ok",
  message: "処理終了",
  result: {
    obj: {
      CouponGoodsNo:"0000000003"
    }
  }
}